export default __webpack_public_path__ + "static/media/yemeng.3e2033ac.jpg";